<template>
  <div>
    <table class="table">
      <tr>
        <td style="text-align:left">
          <button
            type="button"
            class="btn btn-outline btn-outline-dark btn-active-light-dark"
            v-on:click="goToBack()"
          >
           <img src="../assets/left.png" />
            Volver
          </button>
        </td>
      </tr>
    </table>

    <div class="card shadow-sm">
      <div class="card-body">
        <b>¿Cómo funcionan las compras en grupo?</b>
        <br />
        <p>
          Las compras en grupo te permiten adquirir cualquiera de nuestros
          productos en descuento junto con otros compradores.
        </p>
        <p>
          Puedes compartir el producto que quieres comprar en grupo con tus
          amigos o conocidos para completar cada grupo de compras lo antes
          posible.
        </p>
        <p>
          Siempre que participes en un grupo de compras, te mantendremos al
          tanto del número de participantes, una vez completado el núumero
          mínimo de participantes para cada grupo, despacharemos el producto a
          todos los compradores.
        </p>
        <p>
          Recuerda que el nustro único canal de comunicación será WhastApp, y
          será el canal por el cual te daremos información sobre el estado de
          tus compras grupaes o individuales
        </p>
        <b>Pago en efectivo contra entrega</b>
        <br />
        <p>
          Todos los pagos de tus compras serán en efectivo contra entrega, no te
          pediremos que consignes o transfieras el dinero a niguna cuenta.
        </p>
        <b>Envíos a todo el país</b>
        <br />
        <p>
          Cada vez que hagas una compra despacharemos el producto a tu ciudad y
          dirección, podrás hacer el seguimiento del mismo mediante la guía de
          correspondencia que te compartiremos vía WhastsApp.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  mounted() {},
  methods: {
    goToBack() {
      this.$router.back();
    },
  },
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main {
  height: 100vh;
}

b {
  margin-top: 10px;
}
</style>
